(function () {
  var STORAGE_KEY = 'tk-compare';
  var MAX_ITEMS = 10;

  function getCompareList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function findIndex(list, productId, variantId) {
    return list.findIndex(function (item) {
      if (variantId && item.variantId) {
        return String(item.variantId) === String(variantId);
      }
      return String(item.id || item) === String(productId);
    });
  }

  function isInCompare(productId, variantId) {
    return findIndex(getCompareList(), productId, variantId) > -1;
  }

  function toggleCompare(productId, productData) {
    var id = String(productId);
    var variantId = productData && productData.variantId ? String(productData.variantId) : null;
    var list = getCompareList();
    var index = findIndex(list, id, variantId);
    var added;

    if (index > -1) {
      list.splice(index, 1);
      added = false;
    } else {
      if (list.length >= MAX_ITEMS) {
        window.dispatchEvent(new CustomEvent('compare:limit', { detail: { max: MAX_ITEMS } }));
        return null;
      }
      list.push(
        productData || { id: id, variantId: variantId, handle: '', title: '', image: '', url: '' }
      );
      added = true;
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent('compare:change', { detail: { productId: id, variantId: variantId, list: list } }));
    updateHeaderCount(list.length);
    return added;
  }

  function removeFromCompare(productId, variantId) {
    var list = getCompareList();
    var index = findIndex(list, productId, variantId);
    if (index > -1) {
      list.splice(index, 1);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      window.dispatchEvent(new CustomEvent('compare:change', { detail: { productId: String(productId), variantId: variantId, list: list } }));
      updateHeaderCount(list.length);
    }
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.tk-compare-count').forEach(function(badge) {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
    document.querySelectorAll('.tk-header__mob-icon--compare').forEach(function(el) {
      el.classList.toggle('has-items', count > 0);
    });
  }

  class CompareButton extends HTMLElement {
    connectedCallback() {
      this.productId = this.dataset.productId;
      this.variantId = this.dataset.variantId || null;
      this.updateState();
      this.addEventListener('click', this.handleClick.bind(this));
      this._onChange = this.handleChange.bind(this);
      window.addEventListener('compare:change', this._onChange);
      this._onLimit = this.handleLimit.bind(this);
      window.addEventListener('compare:limit', this._onLimit);

      this._onVariantUpdate = this.handleVariantUpdate.bind(this);
      var scope = this.closest('.shopify-section, product-card');
      if (scope) {
        this._variantScope = scope;
        scope.addEventListener('variant:update', this._onVariantUpdate);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('compare:change', this._onChange);
      window.removeEventListener('compare:limit', this._onLimit);
      if (this._variantScope) {
        this._variantScope.removeEventListener('variant:update', this._onVariantUpdate);
        this._variantScope = null;
      }
    }

    handleVariantUpdate(e) {
      var resource = e.detail && e.detail.resource;
      if (!resource) return;
      this.variantId = String(resource.id);
      this.dataset.variantId = this.variantId;

      var variantTitle = resource.title && resource.title !== 'Default Title' ? resource.title : '';
      this.dataset.variantTitle = variantTitle;

      if (resource.url) {
        this.dataset.url = resource.url;
      } else {
        var baseUrl = this.dataset.url ? this.dataset.url.split('?')[0] : '';
        if (baseUrl) this.dataset.url = baseUrl + '?variant=' + resource.id;
      }

      requestAnimationFrame(function () {
        var galleryImg = this.getGalleryImage();
        if (galleryImg) this.dataset.image = galleryImg;
      }.bind(this));

      this.updateState();
    }

    getGalleryImage() {
      var card = this.closest('product-card, .product-card');
      if (card) {
        var img = null;
        if (this.variantId) {
          img = card.querySelector('slideshow-slide[slide-id="variant-meta-' + this.variantId + '"] img');
        }
        if (!img) img = card.querySelector('slideshow-slide:first-child img');
        return img ? img.src : null;
      }
      var section = this.closest('.shopify-section');
      if (section) {
        var img = section.querySelector('media-gallery slideshow-slides slideshow-slide:first-child img');
        return img ? img.src : null;
      }
      return null;
    }

    handleClick(e) {
      e.preventDefault();
      e.stopPropagation();

      var image = this.dataset.image || '';
      var galleryImg = this.getGalleryImage();
      if (galleryImg) image = galleryImg;

      var data = {
        id: String(this.productId),
        variantId: this.variantId ? String(this.variantId) : null,
        handle: this.dataset.handle || '',
        title: this.dataset.title || '',
        variantTitle: this.dataset.variantTitle || '',
        image: image,
        url: this.dataset.url || '',
      };

      var result = toggleCompare(this.productId, data);
      if (result === null) {
        this.showLimitToast();
        return;
      }
      this.classList.toggle('is-active', result);

      var svg = this.querySelector('svg');
      if (svg) {
        svg.animate(
          [{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }],
          { duration: 300, easing: 'ease-out' }
        );
      }
    }

    showLimitToast() {
      var existing = document.querySelector('.tk-compare-toast');
      if (existing) existing.remove();
      var toast = document.createElement('div');
      toast.className = 'tk-compare-toast';
      var frame = (window.tkI18n && window.tkI18n.compare_max_items) || 'You can compare up to %COUNT% products';
      toast.textContent = frame.replace('%COUNT%', MAX_ITEMS);
      document.body.appendChild(toast);
      setTimeout(function () { toast.remove(); }, 3000);
    }

    handleChange(e) {
      var detail = e.detail;
      if (this.variantId && detail.variantId) {
        if (String(detail.variantId) === String(this.variantId)) this.updateState();
      } else if (String(detail.productId) === String(this.productId)) {
        this.updateState();
      }
    }

    handleLimit() {}

    updateState() {
      this.classList.toggle('is-active', isInCompare(this.productId, this.variantId));
    }
  }

  customElements.define('compare-button', CompareButton);

  window.MoCompare = {
    getCompareList: getCompareList,
    isInCompare: isInCompare,
    toggleCompare: toggleCompare,
    removeFromCompare: removeFromCompare,
    updateHeaderCount: updateHeaderCount
  };
})();
